import BaseAutocomplete from './baseAutocomplete'
import { ISalesOrder } from 'interfaces/ISalesOrder'

const headers = [
  {
    id: 'productName',
    numeric: false,
    disablePadding: true,
    label: 'Nama',
    width: 'medium',
  },
  {
    id: 'packagingId',
    numeric: false,
    disablePadding: false,
    label: 'Kemasan',
    width: 'medium',
  },
  {
    id: 'weight',
    numeric: false,
    disablePadding: false,
    label: 'Berat',
    width: 'small',
  },
  {
    id: 'unitPrice',
    numeric: false,
    disablePadding: false,
    label: 'Harga',
    width: 'small',
    isPrice: true,
  },

  {
    id: 'brandId',
    numeric: false,
    disablePadding: false,
    label: 'Merek',
    width: 'small',
  },
  {
    id: 'halal',
    numeric: false,
    disablePadding: false,
    label: 'Halal',
    width: 'tiny',
    isCheckbox: true,
  },
  {
    id: 'box',
    numeric: false,
    disablePadding: false,
    label: 'Dus',
    width: 'tiny',
    isCheckbox: true,
  },
  {
    id: 'wrap',
    numeric: false,
    disablePadding: false,
    label: 'Shrink Wrap',
    width: 'tiny',
    isCheckbox: true,
  },
  {
    id: 'seal',
    numeric: false,
    disablePadding: false,
    label: 'Segel',
    width: 'tiny',
    isCheckbox: true,
  },
]

export default function LoadSalesOrderAutocomplete(props: {
  name?: string
  brandId?: string
  onChange?: (salesOrder: ISalesOrder) => void
  disabled?: boolean
  required?: boolean
  showInactive?: boolean
  getMatchedData?: (salesOrders: ISalesOrder[]) => void
  showDetailedTable?: boolean
  loadAll?: boolean
  label?: string
  factoryType?: string
}) {
  const { name, loadAll, label, factoryType } = props

  let url = '/salesOrders/getSalesOrder'

  const responseMapper = (salesOrder: ISalesOrder) => {
    return `${salesOrder.otDisplayId || salesOrder.salesOrderDisplayId}`
  }

  return (
    <BaseAutocomplete
      {...props}
      url={url}
      headers={headers}
      label={label || 'No. SO'}
      extraParams={{
        salesOrderStatus: 'Pending',
        ...(factoryType && { factoryType }),
      }}
      loadAll={loadAll}
      loadSalesOrderDisplayId
      name={name}
      responseMapper={responseMapper}
    />
  )
}
